export default __webpack_public_path__ + "static/media/tete21.20c41a4e.png";